export type SessionExpiredReason = 'unauthorized' | 'token_expired';

type SessionExpiredHandler = (reason: SessionExpiredReason) => void;

let sessionExpiredHandler: SessionExpiredHandler | null = null;
let handlingSessionExpiry = false;

export function registerSessionExpiredHandler(
  handler: SessionExpiredHandler | null
): void {
  sessionExpiredHandler = handler;
}

export function notifySessionExpired(reason: SessionExpiredReason): void {
  if (handlingSessionExpiry || !sessionExpiredHandler) {
    return;
  }
  handlingSessionExpiry = true;
  try {
    sessionExpiredHandler(reason);
  } finally {
    window.setTimeout(() => {
      handlingSessionExpiry = false;
    }, 500);
  }
}

export function isAuthPublicPath(url: string): boolean {
  const path = (url || '').split('?')[0];
  const publicPaths = [
    '/v1/users/login',
    '/v1/users/register',
    '/v1/users/password-reset',
    '/v1/users/password-reset/confirm',
    '/v1/users/verify-email',
    '/v1/organization-invitations/accept',
  ];
  return publicPaths.some(
    publicPath => path === publicPath || path.endsWith(publicPath)
  );
}
